import React from 'react'
import {Route} from 'react-router-dom'

import AssetModelServiceListPage from './pages/AssetModelServiceListPage/AssetModelServiceListPage';
import { ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_ASSET_MODEL_SERVICE, ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_ASSET_MODEL_SERVICE_EDIT, ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_ASSET_MODEL_SERVICE_CREATE } from '../../../../../../../../constants/route-constant';
import AssetModelServiceChangePage from './pages/AssetModelServiceChangePage/AssetModelServiceChangePage';

class AssetModelServicePage extends React.Component {
  render () {
    return (
      <div
        style={{
          height: '100%',
          width: '100%'
        }}
      >
        <Route
          exact
          path={ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_ASSET_MODEL_SERVICE}
          render={props => (<AssetModelServiceListPage {...props} />)}
        />

        <Route
          path={ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_ASSET_MODEL_SERVICE_CREATE}
          render={props => (<AssetModelServiceChangePage {...props} />)}
        />

        <Route
          path={ROUTE_DASHBOARD_ASSET_CONTROL_REGISTRY_ASSET_MODEL_SERVICE_EDIT}
          render={props => (<AssetModelServiceChangePage {...props} />)}
        />
      </div>
    )
  }
}

export default AssetModelServicePage
